import { render, staticRenderFns } from "./centerPart.vue?vue&type=template&id=08e0499a&"
import script from "./centerPart.vue?vue&type=script&lang=js&"
export * from "./centerPart.vue?vue&type=script&lang=js&"
import style0 from "./centerPart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports